import { Component, OnInit, Input, Output, EventEmitter, ViewChild, HostListener } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { AddpartyComponent } from '../../party/addparty/addparty.component';
import { ComponentCanDeactivate } from '../../PendingChangesGuard';
import { NgSelectComponent } from '@ng-select/ng-select';
@Component({
  selector: 'app-addaccount',
  templateUrl: './addaccount.component.html',
  styleUrls: ['./addaccount.component.css']
})
export class AddaccountComponent implements OnInit {

  //terms Values
  isaddterms: boolean = false;
  iseditterms: boolean = false;
  isdeleteterms: boolean = false;
  isviewterms: boolean = false;

  isDisabled: boolean ;
  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  //Edit Get Values
  accountColl: any = [];


  accountbranchColl: any = [];
  accounttypeColl: any = [];
  aBO: any = [];
  subaccountColl: any = [];


  accountform = new FormGroup({
    accountid: new FormControl(null),
    accountname: new FormControl('', Validators.required),
    accountcode: new FormControl('', Validators.required),
    descr: new FormControl(''),
    accounttypeid: new FormControl(null, Validators.required),
    subaccountid: new FormControl(null),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Ledger";

  @Input() accountid: number = 0
  @Output() emitData = new EventEmitter();

  constructor(private appService: DhukanDataService, private route: ActivatedRoute,private activeModal: NgbActiveModal,
    private productFindService: NgbModal,public router: Router, private toastr: ToastrService, private loginService: LoginDataService) {
   
    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }

        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddterms = true;
      this.accountform.reset();
      this.fnInitializeAccountFormGroup();

      if (this.accountid > 0) {
        this.fngetAccount();
      }
     
      //this.fngetSubAccount();
      this.fngetAccountType();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.accountid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeAccountFormGroup() {
    this.accountform.setValue({
      accountid: 0,
      accountname: '',
      accountcode: 'New',
      descr: '',
      accounttypeid: null,
      subaccountid: null,
      inactive: false,
    })
  }


  //Get 
  fngetAccount() {
    var data = {
      'accountid': this.accountid,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),     
    }
    this.appService.getAccount(data)
      .subscribe(
        (res) => {
          this.accountColl = res.json().result;
          var editdata = this.accountColl[0];
          this.aBO = editdata;
          this.fnEditterms(editdata);

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  // fngetSubAccount() {
  //   var data = {
  //     'accountid': 0,
  //     'companyid': this.loginService.fnGetCompanyId(),
  //     'organizationid': this.loginService.fnGetOrganizationId(),     
  //   }
  //   this.appService.getAccount(data)
  //     .subscribe(
  //       (res) => {
  //         this.subaccountColl = res.json().result;
  //       },
  //       (err) => {
  //         this.toastr.error('Error', err);
  //       })
  // }

  fngetAccountType() {
    var data = {
      'accountypeid': 0,
      'organizationid': this.loginService.fnGetOrganizationId(),     
    }
    this.appService.getAccounttype(data)
      .subscribe(
        (res) => {
          this.accounttypeColl = res.json().result;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.accountform.valid) {
        //Check
        var data = {
          'accountid': this.accountid,
          'accountname': this.accountform.get('accountname').value,
          'accountcode': this.accountform.get('accountcode').value,
          'descr': this.accountform.get('descr').value,
          'accounttypeid': this.accountform.get('accounttypeid').value,
          'subaccountid': this.accountform.get('subaccountid').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'inactive': this.accountform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
          'organizationid': this.loginService.fnGetOrganizationId(),     
         
        }
        this.appService.fnCheckAccount(data).subscribe(
          (res) => {
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.accountform.get('accountid').value > 0) {
                //Update Department
                this.fnSetAccount(data);
              }
              else {
                //Insert Department
                this.fnInsertAccount(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.accountform.controls['accountname'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertAccount(data) {

    this.appService.fnInsertAccount(data).subscribe(
      (res) => {
        if (res.json().status===200) {
          //////this.toastr.success('', "The new Account has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.accountid);

          this.emitData.emit( data.accountid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetAccount(data) {

    this.appService.fnSetAccount(data).subscribe(
      (res) => {
        if (res.json().status===200) {
       
          ////this.toastr.success('', "The Account has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.accountid, data.accountname);

          this.emitData.emit(this.accountid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }
  fnEditAccount() {

    try {
      var deptid = this.accountid

      const modalRef = this.productFindService.open(AddaccountComponent, { size: <any>'l', backdrop: 'static' });
      modalRef.componentInstance.accountid = deptid;

      modalRef.componentInstance.ngOnInit();
      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

        this.fngetAccount();

      });

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  //Close
  fnCloseAccount() {
    try {
      this.activeModal.close(false);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnEditBtnClick() {
    this.iseditterms = true;
    this.isviewterms = false;

  }
  private fnEditterms(deptBO) {

    this.accountform.setValue({
      accountid: deptBO.accountid,
      accountname: deptBO.accountname,
      accountcode: deptBO.accountcode,
      descr: deptBO.descr,
      accounttypeid: deptBO.accounttypeid,
      subaccountid: null,
      inactive: deptBO.inactive,
    });


    this.isaddterms = false;
    this.iseditterms = false;
    this.isdeleteterms = false;
    this.isviewterms = true;
  }

  public decline() {
    this.activeModal.close(false);
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


      // this.appService.fnInsertActivity(data).subscribe(
      //   (res)=>{
      //   },
      //   (err)=>{

      //   });

    } catch {

    }
  }



  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
